import { createFileRoute, redirect } from "@tanstack/react-router";

// DEPRECATED (product, 2026-05-19): the Call Time "Results" view is shelved
// for now, together with the Call Time in-page sub-nav. The route is kept as
// a redirect so old deep links / bookmarks resolve to the call list instead
// of 404ing. The CallTimeResults component, useCallTimeResults hook, and the
// backend results endpoints are intentionally left intact. To restore: drop
// this redirect, re-add the page component, and re-add the "Results" tab in
// _.call-time.tsx.
export const Route = createFileRoute("/_app/_/call-time/results")({
	beforeLoad: () => {
		throw redirect({ to: "/call-time" });
	},
});
